import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { InadimplenciaHistoricalOverview } from '@/features/inadimplencia/types/InadimplenciaHistoricalOverview.ts';

async function getTermometroGeralMetricasAlunos(params): Promise<InadimplenciaHistoricalOverview> {
  const api = await getApi();
  const { data } = await api.get<InadimplenciaHistoricalOverview>('/termometro/geral/metricas_alunos/', {params});
  return data;
}

type QueryFnType = typeof getTermometroGeralMetricasAlunos;

function useTermometroGeralMetricasAlunos(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-termometro-geral-metrica-alunos',params ],
    queryFn: () =>  getTermometroGeralMetricasAlunos(params),
  });
}

export { useTermometroGeralMetricasAlunos };
